import React from 'react';
import { Container, Description, Icon, MaintenanceWrapper, StatusBox, StatusText, Title } from './styles';

export const Maintenance = () => {
    return (
        <MaintenanceWrapper>
            <Container>
                <Icon>🔧</Icon>
                <Title>We&apos;ll Be Right Back</Title>
                <Description>
                    We&apos;re currently performing scheduled maintenance to improve your experience.
                </Description>
                <Description>We apologize for any inconvenience and appreciate your patience.</Description>

                <StatusBox>
                    <StatusText>Maintenance in Progress</StatusText>
                </StatusBox>
            </Container>
        </MaintenanceWrapper>
    );
};
